'use client'

import Image from 'next/image'
import { useRouter } from 'next/router'
import type { FunctionComponent } from 'react'
import styles from './SelectLocales.module.sass'
import { useLocales } from './contexts/SwitcherLocalesContext'

export const SelectLocales: FunctionComponent = () => {
	const locales = useLocales()
	const router = useRouter()

	if (!locales || !locales.pageLocales || locales.pageLocales.length <= 1) {
		return null
	}

	return (
		<div className={styles.localeSwitch}>
			{locales.pageLocales.map(item => {
				const code = item.locale?.code
				const isActive = code === locales.currentLocaleCode
				const link = item.link?.url ?? `/${code}`

				return (
					<button
						type="button"
						key={code}
						className={`${styles.localeButton} ${isActive ? styles.active : styles.inactive}`}
						onClick={() => router.push(link, undefined, { locale: code })}
					>
						{item.locale?.flagImage && (
							<Image
								className={styles.flagImage}
								src={item.locale.flagImage.url}
								width={item.locale.flagImage.width}
								height={item.locale.flagImage.height}
								alt={item.locale.flagImage.alt ?? item.locale.flagImage.fileName ?? ''}
							/>
						)}
						<span>{code}</span>
					</button>
				)
			})}
		</div>
	)
}
